/** Flutterwave hosted-checkout query statuses that mean the user abandoned payment. */
const ABANDONED_STATUSES = new Set(['cancelled', 'canceled', 'failed']);

/**
 * True when Flutterwave redirected back without a completable charge.
 * Do not call verify — there is no transaction to look up.
 */
export function isFlutterwaveAbandonedReturn(
    params: Pick<URLSearchParams, 'get'>,
): boolean {
    const status = String(params.get('status') ?? '')
        .trim()
        .toLowerCase();
    return ABANDONED_STATUSES.has(status);
}
